import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  getAllAtmedBookingLab, getAtmedBookingLab,
} from '../../../store/actions';
import Booking from './booking';

const mapStateToProps = ({ vendorEquipmenReducer }) => ({
  results: vendorEquipmenReducer.results
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getAllAtmedBookingLab,
    getAtmedBookingLab
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(Booking);
